module.exports = __webpack_public_path__ + "img/lingkungan_dan_biologi.0761e469.svg";